import http from "plugins/axios";

export default {
  getAllCoin() {
    return http.get({
      url: "/la/admin/coin/all",
    });
  },
  //删除K线数据
  delKlineData(symbol){
    return http.get({
      url:`/la/admin/inner/kline/del?symbol=${symbol}`
    })
  },
  // 按选择的周期提交K线更新任务
  getKlineData({ symbolId, types }){
    return http.post({
      url: "/la/admin/inner/kline/import",
      data: { symbolId, types },
    })
  },
  //所有交易对查询
  getAllSymbol({ page, size, symbol ,buyCoin,state}) {
    return http.get({
      url: `/la/admin/symbol/findAll?buyCoin=${buyCoin}&page=${page}&size=${size}&symbol=${symbol}&state=${state}`,
      // data: {
      //   page,
      //   size,
      //   symbol,
      // },
      dataType: "form",
    });
  },
  //hot开关
  hotSwitch({id,hot}){
    return http.post({
      url:`/la/admin/symbol/hot?id=${id}&hot=${hot}`
    })
  },
//开启隐藏
  symbolSwitch({ id, type }) {
    return http.post({
      url: `/la/admin/symbol/symbolSwitch?id=${id}&type=${type}`,
     
    });
  },
  //交易开关
  tradeSwitch({ id, type }) {
    return http.post({
      url: `/la/admin/symbol/tradeSwitch?id=${id}&type=${type}`,
     
    });
  },
  //更新交易对信息
  updateSymbol( symbol ) {
    return http.post({
      url: "/la/admin/symbol/changeSymbol",
      data: {
        ...symbol,
      },
    });
  },
  //新建交易对请求
  createTradeSymbol(data){
    return http.post({
      url:'/la/admin/symbol/insert',
      data:{...data}
    })
  },
  //删除交易对
  delSymbol(id){
    return http.post({
      url:`/la/admin/symbol/delSymbol?id=${id}`,
      
    })
  },

  getTradePairList({ pair, area, page, size }) {
    return http.post({
      url: "/la/admin/tradePair/list",
      data: {
        pair,
        area,
        page,
        size,
      },
      dataType: "form",
    });
  },
  updateTradeStatus({ pair, status, amount, price }) {
    return http.post({
      url: `/la/admin/tradePair/update/${pair}/trade/${status}`,
      data: { amount, price },
      dataType: "form",
    });
  },
  createTradePair(data) {
    return http.post({
      url: "/la/admin/tradePair/create",
      data,
      dataType: "form",
    });
  },
  
  updateTradePair(data) {
    return http.post({
      url: "/la/admin/tradePair/update/type",
      data,
      dataType: "form",
    });
  },
  removeTradePair(pair) {
    return http.post({
      url: "/la/admin/tradePair/remove",
      data: {
        pair,
      },
      dataType: "form",
    });
  },
  updateDefaultPrecision({ pair, precision }) {
    return http.post({
      url: "/la/admin/tradePair/update/defaultPrecision",
      data: {
        pair,
        precision,
      },
      dataType: "form",
    });
  },
  updateAmountPrecision({ pair, precision }) {
    return http.post({
      url: "/la/admin/tradePair/update/amountPrecision",
      data: {
        pair,
        precision,
      },
      dataType: "form",
    });
  },
  transaction(pair) {
    return http.post({
      url: "/la/admin/transaction",
      data: {
        pair,
      },
      dataType: "form",
    });
  },
  getTradeArea() {
    return http.get({
      url: "/la/admin/tradePair/area",

    });
  },
  updateSort({ pair, orderNo }) {
    return http.post({
      url: `/la/admin/tradePair/update/${pair}/sort`,
      data: {
        pair,
        orderNo,
      },
      dataType: "form",
    });
  },
};
